import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { TextBoxComponent } from '@progress/kendo-angular-inputs';
import { forkJoin, Observable } from 'rxjs';
import { DestroyBase } from 'src/app/components/common/ng-destroy-base';
import { RefListModel } from 'src/app/models/ref-list-model';
import { CalculationModelOverview } from '../../../models/calculation-model-overview';
import { CalculationModelService } from '../../../services/calculation-model-service';

/**
 * Calculation model search area
 */
@Component({
  selector: 'calculation-model-search-area',
  templateUrl: './calculation-model-search-area.component.html',
  styleUrls: ['./calculation-model-search-area.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class CalculationModelSearchAreaComponent extends DestroyBase implements OnInit {
  /**
   * Country ref list
   */
  countryRefList: RefListModel[] = [];

  /**
   * Status ref list
   */
  statusRefList: RefListModel[] = [];

  /**
   * Sector ref list
   */
  sectorRefList: RefListModel[] = [];

  /**
   * Valuation method ref list
   */
  valuationMethodRefList: RefListModel[] = [];

  /**
   * Search model
   */
  searchModel = new CalculationModelOverview();

  /**
   * Search settings event emitter
   */
  @Output() search: EventEmitter<CalculationModelOverview> = new EventEmitter();

  /**
   * The name field
   */
  @ViewChild('nameField') nameField: TextBoxComponent;

  /**
   * Constructor
   * @param cmService CalculationModelService
   * @param ref ChangeDetectorRef
   */
  constructor(private cmService: CalculationModelService, private ref: ChangeDetectorRef) {
    super();
  }

  /**
   * Initializes the component
   */
  ngOnInit(): void {
    this.searchModel.name = '';
    this.subscriptions.add(this.requestRefLists().subscribe(responseList => {
      this.countryRefList = responseList[0];
      this.statusRefList = responseList[1];
      this.sectorRefList = responseList[2];
      this.valuationMethodRefList = responseList[3];
    }));

    this.subscriptions.add(this.cmService.resetSearch$.subscribe(() => {
      if (this.nameField) {
        this.nameField.clearValue();
      }
      this.clearSearch();
    }));
  }

  /**
   * Loads the ref lists
   */
  private requestRefLists(): Observable<any[]> {
    const countryRefList = this.cmService.getRefList('ref_valuation_country');
    const statusRefList = this.cmService.getRefList('ref_calculation_model_template_status');
    const sectorRefList = this.cmService.getRefList('ref_calculation_model_template_sector');
    const valueationMethodRefList = this.cmService.getRefList('ref_calculation_model_template_valuation_method');

    return forkJoin([countryRefList, statusRefList, sectorRefList, valueationMethodRefList]);
  }

  /**
   * Triggers the search
   */
  triggerSearch() {
    this.search.emit(this.searchModel);
  }

  /**
   * Clears the search
   */
  clearSearch() {
    this.searchModel = new CalculationModelOverview();
    this.searchModel.name = '';
    this.ref.markForCheck();
    this.triggerSearch();
  }
}
